// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: "Open Sans", serif;
    font-optical-sizing: auto;
    font-style: normal;
    font-variation-settings: "wdth" 100;
}

html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;
}

:root {
    --color-primary: #44484b; /* green */
    --color-primary-light: #b1b2b4; /* green */
    --color-secondary-dark: #857a6d; /* coffee-dark */
    --color-secondary: #c2bab0; /* coffee */
    --color-secondary-light: #e5dfd7; /* coffee-light */
    --color-general-black: #1c1a19;
    --color-general-white: #ffffff;
    --color-general-background: #efefef;
    --color-gray1: #515255;
    --color-gray2: #a6a4a3;
    --color-gray3: #c3c3c3;
    --color-gray4: #f9f9f9;
    --color-status-error: #c20909;

    --border-radius: 12px;

    --app-offset-left: 60px;
    --app-offset-right: 60px;
    --app-offset-top: 40px;
    --app-offset-bottom: 48px;
    --app-column-gap: 20px;
    --app-column-count: 12;

    --app-offset-h-sum: calc(var(--app-offset-left) + var(--app-offset-right));
    --app-column-width: calc(
        (100vw - var(--app-offset-h-sum) - (var(--app-column-count) - 1) * var(--app-column-gap)) /
            var(--app-column-count)
    );
    --grid-width-1: var(--app-column-width);
    --grid-width-2: calc(var(--app-column-width) * 2 + var(--app-column-gap));
    --grid-width-3: calc(var(--app-column-width) * 3 + var(--app-column-gap) * 2);
    --grid-width-4: calc(var(--app-column-width) * 4 + var(--app-column-gap) * 3);
    --grid-width-5: calc(var(--app-column-width) * 5 + var(--app-column-gap) * 4);
    --grid-width-6: calc(var(--app-column-width) * 6 + var(--app-column-gap) * 5);
    --grid-width-7: calc(var(--app-column-width) * 7 + var(--app-column-gap) * 6);
    --grid-width-8: calc(var(--app-column-width) * 8 + var(--app-column-gap) * 7);
    --grid-width-9: calc(var(--app-column-width) * 9 + var(--app-column-gap) * 8);
    --grid-width-10: calc(var(--app-column-width) * 10 + var(--app-column-gap) * 9);
    --grid-width-11: calc(var(--app-column-width) * 11 + var(--app-column-gap) * 10);
    --grid-width-12: calc(var(--app-column-width) * 12 + var(--app-column-gap) * 11);
}

body {
    color: var(--color-general-black, #1c1a19);
}

.grid-width-1 {
    width: var(--grid-width-1);
}

.grid-width-2 {
    width: var(--grid-width-2);
}

.grid-width-3 {
    width: var(--grid-width-3);
}

.grid-width-4 {
    width: var(--grid-width-4);
}

.grid-width-5 {
    width: var(--grid-width-5);
}

.grid-width-6 {
    width: var(--grid-width-6);
}

.typography-headline {
    font-family: "Manrope", sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
}

.typography-title {
    font-family: "Manrope", sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
}

.typography-subtitle {
    font-family: "Manrope", sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}

body,
.typography-body {
    font-family: "Manrope", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}

.typography-body-medium {
    font-family: "Manrope", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}

.typography-label {
    font-family: "Manrope", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
}

.typography-badge {
    font-family: "Manrope", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
}

.rc-trigger-popup {
    position: fixed;
    z-index: 10001;
}

hr {
    border-color: var(--color-secondary-dark);
    opacity: unset;
    margin: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,wBAAwB,EAAE,UAAU;IACpC,8BAA8B,EAAE,UAAU;IAC1C,+BAA+B,EAAE,gBAAgB;IACjD,0BAA0B,EAAE,WAAW;IACvC,gCAAgC,EAAE,iBAAiB;IACnD,8BAA8B;IAC9B,8BAA8B;IAC9B,mCAAmC;IACnC,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,6BAA6B;;IAE7B,qBAAqB;;IAErB,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;;IAEtB,0EAA0E;IAC1E;;;KAGC;IACD,uCAAuC;IACvC,yEAAyE;IACzE,6EAA6E;IAC7E,6EAA6E;IAC7E,6EAA6E;IAC7E,6EAA6E;IAC7E,6EAA6E;IAC7E,6EAA6E;IAC7E,6EAA6E;IAC7E,+EAA+E;IAC/E,gFAAgF;IAChF,gFAAgF;AACpF;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,cAAc;IACd,WAAW;AACf","sourcesContent":["body {\n    font-family: \"Open Sans\", serif;\n    font-optical-sizing: auto;\n    font-style: normal;\n    font-variation-settings: \"wdth\" 100;\n}\n\nhtml,\nbody {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    overflow: hidden;\n}\n\n:root {\n    --color-primary: #44484b; /* green */\n    --color-primary-light: #b1b2b4; /* green */\n    --color-secondary-dark: #857a6d; /* coffee-dark */\n    --color-secondary: #c2bab0; /* coffee */\n    --color-secondary-light: #e5dfd7; /* coffee-light */\n    --color-general-black: #1c1a19;\n    --color-general-white: #ffffff;\n    --color-general-background: #efefef;\n    --color-gray1: #515255;\n    --color-gray2: #a6a4a3;\n    --color-gray3: #c3c3c3;\n    --color-gray4: #f9f9f9;\n    --color-status-error: #c20909;\n\n    --border-radius: 12px;\n\n    --app-offset-left: 60px;\n    --app-offset-right: 60px;\n    --app-offset-top: 40px;\n    --app-offset-bottom: 48px;\n    --app-column-gap: 20px;\n    --app-column-count: 12;\n\n    --app-offset-h-sum: calc(var(--app-offset-left) + var(--app-offset-right));\n    --app-column-width: calc(\n        (100vw - var(--app-offset-h-sum) - (var(--app-column-count) - 1) * var(--app-column-gap)) /\n            var(--app-column-count)\n    );\n    --grid-width-1: var(--app-column-width);\n    --grid-width-2: calc(var(--app-column-width) * 2 + var(--app-column-gap));\n    --grid-width-3: calc(var(--app-column-width) * 3 + var(--app-column-gap) * 2);\n    --grid-width-4: calc(var(--app-column-width) * 4 + var(--app-column-gap) * 3);\n    --grid-width-5: calc(var(--app-column-width) * 5 + var(--app-column-gap) * 4);\n    --grid-width-6: calc(var(--app-column-width) * 6 + var(--app-column-gap) * 5);\n    --grid-width-7: calc(var(--app-column-width) * 7 + var(--app-column-gap) * 6);\n    --grid-width-8: calc(var(--app-column-width) * 8 + var(--app-column-gap) * 7);\n    --grid-width-9: calc(var(--app-column-width) * 9 + var(--app-column-gap) * 8);\n    --grid-width-10: calc(var(--app-column-width) * 10 + var(--app-column-gap) * 9);\n    --grid-width-11: calc(var(--app-column-width) * 11 + var(--app-column-gap) * 10);\n    --grid-width-12: calc(var(--app-column-width) * 12 + var(--app-column-gap) * 11);\n}\n\nbody {\n    color: var(--color-general-black, #1c1a19);\n}\n\n.grid-width-1 {\n    width: var(--grid-width-1);\n}\n\n.grid-width-2 {\n    width: var(--grid-width-2);\n}\n\n.grid-width-3 {\n    width: var(--grid-width-3);\n}\n\n.grid-width-4 {\n    width: var(--grid-width-4);\n}\n\n.grid-width-5 {\n    width: var(--grid-width-5);\n}\n\n.grid-width-6 {\n    width: var(--grid-width-6);\n}\n\n.typography-headline {\n    font-family: \"Manrope\", sans-serif;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 40px;\n}\n\n.typography-title {\n    font-family: \"Manrope\", sans-serif;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 28px;\n}\n\n.typography-subtitle {\n    font-family: \"Manrope\", sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n\nbody,\n.typography-body {\n    font-family: \"Manrope\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n.typography-body-medium {\n    font-family: \"Manrope\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n\n.typography-label {\n    font-family: \"Manrope\", sans-serif;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n}\n\n.typography-badge {\n    font-family: \"Manrope\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n}\n\n.rc-trigger-popup {\n    position: fixed;\n    z-index: 10001;\n}\n\nhr {\n    border-color: var(--color-secondary-dark);\n    opacity: unset;\n    margin: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
